var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnhide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5976 1.10523L16.8659 0.365064C16.6591 0.155881 16.275 0.185682 16.0333 0.472243L13.4586 3.00145C12.3094 2.49889 11.0469 2.25163 9.71884 2.24399C5.7667 2.23721 2.32973 4.52146 0.6626 7.82414C0.565378 8.03158 0.563907 8.2875 0.658921 8.46404C1.41783 10.0364 2.56243 11.3391 3.9968 12.3233L1.88861 14.4392C1.64723 14.6778 1.61301 15.0616 1.77186 15.2705L2.50356 16.0107C2.71035 16.2198 3.09452 16.19 3.33617 15.9035L17.4646 1.93659C17.77 1.69847 17.8042 1.3147 17.5974 1.1055L17.5976 1.10523ZM10.5459 5.89665C10.2742 5.83107 9.98673 5.74946 9.71471 5.7479C8.35469 5.74008 7.26056 6.82183 7.25275 8.18172C7.25118 8.45372 7.31354 8.74203 7.39193 9.01451L6.31376 10.0644C5.99703 9.50258 5.82463 8.87747 5.82868 8.17357C5.84091 6.04562 7.56275 4.34347 9.6907 4.3557C10.3947 4.35975 11.0177 4.53932 11.5758 4.86249L10.5459 5.89665Z",
    fill: "#666666",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7109 7.92784C18.1574 6.8046 17.4271 5.79245 16.5199 4.97119L13.527 7.89804L13.5252 8.21799C13.5129 10.3459 11.7911 12.0481 9.66316 12.0359L9.34321 12.034L7.4444 13.9111C8.14762 14.0591 8.883 14.1594 9.60299 14.1635C13.5551 14.1862 16.992 11.902 18.6592 8.58338C18.8045 8.36014 18.8058 8.13623 18.711 7.92767L18.7109 7.92784Z",
    fill: "#666666",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhide);
export default __webpack_public_path__ + "static/media/unhide.8cb1c36aefc5d24ded8f33f657af99a4.svg";
export { ForwardRef as ReactComponent };